<template>
  <div>
    <add-service-item
      :openItem="false"
      :fieldsFrom="fields"
      :setLink="setLink"
      :cardLink="cardLink"
      :params="params"
      @input="$emit('input', item)"
    />
  </div>
</template>
<script>
import AddServiceItem from "../../Modals/AddServiceItem.vue";
export default {
  components: { AddServiceItem },
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  props: ["data"],

  computed: {},

  data() {
    return {
      params: {},
      item: null,
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          label: "Номер телефона",
          key: "order_service_id",
          type: "hidden",
          default: this.data.id,
        },
        {
          label: "Имя",
          key: "first_name",
          type: "field",
          default: this.data.order.client.first_name,
        },
        {
          label: "Фамилия",
          key: "last_name",
          type: "field",
          default: this.data.order.client.last_name,
        },
        {
          label: "Цена заказа",
          key: "price_purchase",
          type: "field",
          default: this.data.order.price_total,
        },

        // {
        //   label: "Ссылка на сервис",
        //   key: "point",
        //   type: "hidden",
        //   default: `${
        //     this.data.service.api_endpoint_url
        //   }?username=${this.$store.state.user.phone.replace("+", "")}_${
        //     this.$store.state.shop ? this.$store.state.shop.id : ""
        //   }&code=${this.$store.state.user.code}&dName=Order&dPrice=${
        //     this.data.order.price_total
        //   }&dUrl=${this.$store.state.host}/api/redirect/order-services/${
        //     this.data.id
        //   }`,
        // },
      ],

      /** APIs */
      removeLink: "",
      cardLink: "item_trade_in",
      itemLink: "trade_ins",
      setLink: "trade_ins",
    };
  },
};
</script>
